import { UserUi } from 'src/app/shared/models/user-ui';
import { apis, controllerTypes, HttpRequestSettings } from '../models/request-settings';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { Injectable, NgZone } from '@angular/core';
import { MemberTypeId } from '@sb-shared/enums/member.type.enum';
import { NgxPendoService } from 'ngx-pendo';

@Injectable({
  providedIn: 'root'
})
export class PendoService {

  config: HttpRequestSettings = {
    api: apis.Core,
    controllerType: controllerTypes.User
  }

  constructor(private http: HttpWebApiService, private ngxPendoService: NgxPendoService) { }

  setup(user: UserUi) {
    // LOU script not loaded.
    if (!window.pendo || !window.EveryBuddy.EnablePendo) {
      console.log('Pendo disabled');
      return;
    }

    console.log('Pendo enabled');

    this.http.get('Info/Tracking', this.config)
      .subscribe(res => {
        let userAccountRole = res.userAccountRole;

        // Override role with current member type - in case of staff/parent viewing as parent.
        switch (user.currentMemberTypeId) {
          case MemberTypeId.Staff:
            userAccountRole = 'Staff';
            break;
          case MemberTypeId.Parent:
            userAccountRole = 'Parent';
            break;
          case MemberTypeId.Student:
            userAccountRole = 'Student';
        }

        this.ngxPendoService.initialize({
          visitor: {
              id: 'SB_' + res.email,
              sb_id: 'SB_' + res.email,
              app: 'SB',
              sb_user_id: res.id,
              sb_user_first_name: res.firstName,
              sb_user_last_name: res.lastName,
              sb_user_created_at: res.createdAtUtc,
              sb_user_last_login_at: res.lastLoggedInDateTimeUtc,
              sb_user_account_role: userAccountRole,
              sb_user_lang: res.userLang,
              sb_user_roles: res.userRoles,
              sb_user_year_group: res.userYearGroup,
              sb_user_subjects: res.userSubjects,
              sb_school_name: res.schoolName,
              sb_school_country: res.schoolCountry,
              sb_email: res.email,
              sb_organisation_id: res.sbOrganisationId,
              sb_site_instance: res.sbSiteInstance
          },

          account: {
              id: 'SB'             
          }
        });
      });
  }
}
